module.exports = __webpack_public_path__ + "static/media/prayer.4223658e.png";